import { arrayBufferToBase64, base64ToByteArray } from '../../utils/utils';
export function deserializeDeviceEntry(item) {
    return ({
        entryId: item.entryId,
        deviceId: item.deviceId,
        companyId: item.companyId,
        groupId: item.groupId,
        policyId: item.policyId,
        policyType: item.policyType,
        policyHash: item.policyHash !== null ? base64ToByteArray(item.policyHash) : null,
        addedAt: new Date(item.addedAt),
        userId: item.userId,
        vaultEntryId: item.vaultEntryId,
        entrySignature: base64ToByteArray(item.entrySignature),
        blockchainSignature: base64ToByteArray(item.blockchainSignature),
        operation: item.operation,
        version: item.version,
    });
}
export function serializeDeviceEntry(item) {
    return ({
        entryId: item.entryId,
        deviceId: item.deviceId,
        companyId: item.companyId,
        groupId: item.groupId,
        policyId: item.policyId,
        policyType: item.policyType,
        policyHash: item.policyHash !== null ? arrayBufferToBase64(item.policyHash) : null,
        addedAt: item.addedAt,
        userId: item.userId,
        vaultEntryId: item.vaultEntryId,
        entrySignature: arrayBufferToBase64(item.entrySignature),
        blockchainSignature: arrayBufferToBase64(item.blockchainSignature),
        operation: item.operation,
        version: item.version,
    });
}
